export default "__VITE_ASSET__BTcZ48Fl__"